import { useQuery } from "@tanstack/react-query";

import { requests } from "../../../../services/http-common";

export type CityOption = { label: string; value: string };

/**
 * City options for one state.
 *
 * Takes the state as an argument rather than reading it from the form: the
 * address and the billing address each have their own state, and sharing a
 * single list left the billing city offering the address state's cities.
 */
export const useCityOptions = (state?: string | null): CityOption[] => {
  const { data } = useQuery({
    queryKey: ["cities", state],
    enabled: !!state,
    queryFn: () => {
      return requests.get(`/administrative-division/usa/cities/${state}`);
    },
    select: (cities: { name: string }[]) =>
      cities.map((city) => ({ label: city.name, value: city.name })),
  });

  return data ?? [];
};
